<template>
  <el-dialog v-if="dialogVisable" class="report-join-setup-dialog" :title="dialog.title" :visible.sync="dialogVisable" append-to-body center width="400px" :close-on-click-modal="false" :close-on-press-escape="false" @close="cancel">
    <el-form v-if="dialogVisable" ref="reportJoinSetupDialog" class="childTable-inline" label-width="120px" :model="dialog.data" :rules="rules">
      <el-form-item label="关联表" prop="referenceTableId">
        <el-select v-model="dialog.data.referenceTableId" placeholder="从表" @change='getRelTableColumns($event, 0)' filterable remote :remote-method="remoteMethod" :loading="optionLoading" >
          <el-option
            v-for="(table, index) in allTables"
            :key="index + '' + 'a'"
            :label="table.name"
            :value="table.id"
            :disabled="table.id === tableId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联表字段" prop="referenceColumnId">
        <public-combobox v-model="dialog.data.referenceColumnId" :options="joinColumns" :placeholder="'从表字段'" :clearable="false"></public-combobox>
      </el-form-item>
      <el-form-item label="主表字段" prop="principalColumnId">
        <public-combobox v-model="dialog.data.principalColumnId" :options="columns" :placeholder="'主表字段'" :clearable="false"></public-combobox>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="save">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {UUID} from '@/plugins/common'
import cache from '../../public/cache'
import publicCombobox from '@/components/public/public-combobox.vue'

export default {
  name: 'ReportJoinSetup',
  props: ['tableId', 'tables'],
  inject: ['reportService'],
  components: {publicCombobox},
  data () {
    return {
      limitTables: this.tables,
      join: {id: '', principalTableId: '', referenceTableId: '', principalColumnId: '', referenceColumnId: '', name: '', use: true, joinType: 'archived'},
      joinColumns: [],
      optionLoading: false,
      keyword: '',
      dialog: {
        title: '添加关联',
        data: {
          referenceTableId: '',
          principalColumnId: '',
          referenceColumnId: ''
        }
      },
      dialogVisable: false,
      rules: {
        referenceTableId: [{ required: true, message: '请选择从表', trigger: 'change' }],
        principalColumnId: [{ required: true, message: '请选择从表字段', trigger: 'change' }],
        referenceColumnId: [{ required: true, message: '请选择主表字段', trigger: 'change' }]
      },
      editData: {},
      allTables: [],
      columns: []
    }
  },
  methods: {
    getPrincipalColumns (tableId) {
      let table = this.reportService.options.tables.find(m => m.id === tableId)
      this.columns = table.columns
    },
    getRelTableColumns (val, clear = null) {
      if (clear === 0) {
        this.dialog.data.referenceColumnId = ''
        this.dialog.data.principalColumnId = ''
      }
      let table = this.reportService.options.tables.find(m => m.id === val)
      // 是归档表
      if (table) {
        this.join.joinType = 'archived'
        if (table.columns) {
          this.joinColumns = table.columns
        } else {
          cache.getData(`/data-api/table/${val}`).then((data) => {
            table.columns = data.columns
            this.joinColumns = data.columns
          })
        }
      } else {
        // 是辅助表
        let dataSourceReport = this.reportService.options.dataSourceReports.find(m => m.id === val)
        if (dataSourceReport) {
          this.join.joinType = 'dataSourceReport'
          this.$axios.get(`/report-api/report/definition/${val}?type=edit`)
            .then(res => {
              res.data.columns.forEach(m => {
                m.show = true
              })
              dataSourceReport.columns = res.data.columns
              this.joinColumns = res.data.columns
            })
        }
      }
    },
    remoteMethod (query) {
      this.keyword = query
      if (query !== '') {
        let arr = this.reportService.options.tables.filter(t => t.name.includes(query) || (t.pinyinName && t.pinyinName.includes(query)) || (t.pinyinFirstChar && t.pinyinFirstChar.includes(query)))
        // 如果报表查询的长度少于是个，需要加上辅助表的
        if (arr.length < 10) {
          let dataSorceReport = this.$_.cloneDeep(this.reportService.options.dataSourceReports)
          let darr = dataSorceReport.filter(t => t.name.includes(query) || (t.pinyinName && t.pinyinName.includes(query)) || (t.pinyinFirstChar && t.pinyinFirstChar.includes(query)))
          darr.forEach(m => {
            m.name = '[辅]' + m.name
          })
          arr = [...arr, ...darr]
        }
        this.allTables = arr.slice(0, 10)
      } else {
        this.allTables = [...this.reportService.options.tables, ...this.reportService.options.dataSourceReports].slice(0, 10)
      }
    },
    async openDialog (title, data = {}) {
      this.dialog.title = title
      if (Object.keys(data).length > 0) {
        if (this.dialog.title === '编辑') {
          this.dialog.data = this.$_.cloneDeep(data)
          this.editData = this.$_.cloneDeep(data)
          await this.getPrincipalColumns(data.principalTableId)
          await this.getRelTableColumns(data.referenceTableId)
        } else {
          this.join.principalTableId = data.principalTableId
          this.join.type = data.type
          await this.getPrincipalColumns(data.principalTableId)
          this.joinColumns = []
        }
      } else {
        this.getPrincipalColumns(this.tableId)
        this.join.principalTableId = this.tableId
        this.joinColumns = []
      }
      this.allTables = [...this.reportService.options.tables, ...this.reportService.options.dataSourceReports].slice(0, 10)
      this.dialogVisable = true
    },
    save () {
      this.$refs.reportJoinSetupDialog.validate(v => {
        if (v) {
          if (this.dialog.title === '添加关联') {
            let data = this.$_.cloneDeep(this.join)
            data = this.$_.merge({...data}, {...this.dialog.data})
            data.id = UUID.create()
            let findNameTables = data.joinType === 'archived' ? this.reportService.options.tables : this.reportService.options.dataSourceReports
            data.name = findNameTables.find(m => m.id === data.referenceTableId).name
            this.$emit('addJoin', {...data})
          } else {
            let data = this.dialog.data
            data.use = this.join.use
            data.joinType = this.join.joinType
            data.id = data.id ? data.id : UUID.create()
            let findNameTables = this.join.joinType === 'archived' ? this.reportService.options.tables : this.reportService.options.dataSourceReports
            let table = findNameTables.find(m => m.id === data.referenceTableId)
            data.name = table ? table.name : ''
            this.$emit('editJoin', data)
          }
        } else {
          return false
        }
      })
    },
    cancel () {
      this.dialogVisable = false
      this.$set(this.dialog, 'data', {
        referenceTableId: '',
        principalColumnId: '',
        referenceColumnId: ''
      })
      this.$set(this, 'joinColumns', [])
    },
    changeTables (obj) {
      // 为了加载从表可能不是存在前10条的问题
      if (obj && obj.referenceTableId) {
        let table = this.tables.find(l => l.id === obj.referenceTableId)
        if (!table) {
          let findNameTables = obj.joinType === 'archived' ? this.reportService.options.tables : this.reportService.options.dataSourceReports
          table = findNameTables.find(l => l.id === obj.referenceTableId)
          if (table) {
            let arr = this.$_.merge([], this.tables.slice(0, 9))
            arr.push({...table})
            this.allTables = arr
          }
        }
      }
    }
  },
  watch: {
    dialogVisable (val) {
      this.changeTables(this.dialog.data)
    }
  }
}
</script>
<style lang="scss">
  .data-list-ralation {
    .childTable-inline {
      bottom: 100px;
      left: 0;
      right: 0;
      text-align: center;
      padding-top: 6px;
      margin-right: 10px;
      margin-top: 20px;

      & > .el-select {
        width: 226px;
        height: 24px;
        line-height: 24px;
        margin-bottom: 10px;
      }

      .el-form-item {
        margin-bottom: 10px;

        .el-button {
          margin-left: -80px;
        }

        &.addButton {
          .el-button {
            width:78px;
            height:26px;
            margin-top: 18px;
            border: 1px solid #55ACF1;
            color: #54ABF1;
            padding: 0;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/report-join-setup.vue